/** The top-level areas of the app, each with its own sidebar. */
export type WorkspaceId = 'one' | 'partner' | 'admin';

const LAST_URL_KEY = 'cyflare.workspace.lastUrl.';
const PREFIX: Record<WorkspaceId, string> = { one: '/customer/', partner: '/partner/', admin: '/admin/' };

/** Remember the page a user was on in an area, so returning to it lands there. */
export function rememberWorkspaceUrl(id: WorkspaceId, url: string): void {
  try {
    sessionStorage.setItem(LAST_URL_KEY + id, url);
  } catch {
    // Storage blocked: returning falls back to the area's home.
  }
}

/** The last page the user had open in an area, if any. */
export function lastWorkspaceUrl(id: WorkspaceId): string | null {
  try {
    const url = sessionStorage.getItem(LAST_URL_KEY + id);
    return url && url.startsWith(PREFIX[id]) ? url : null;
  } catch {
    return null;
  }
}
